export const reviews = [
  {
    name: "Julia V",
    rating: 5,
    comment: "My husband, two daughters, and I just visited the Lucky Claww location at the University District and had a blast! It was our girls' first time at an arcade environment. Because of their play and win system, our girls got to not only enjoy using a claw machine, but also feel good winning and getting a prize at the end! Big shout out to staff member Jayla, who was really helpful and friendly for our entire time there!",
    date: "Jan 24, 2026"
  },
  {
    name: "Daratina P",
    rating: 5,
    comment: "This is a suitable place for young people, dating, and family. Although the shop is a bit small, it is reasonable to relieve stress and fun. Price to buy token is okay, not too expensive, can trade.",
    date: "2 weeks ago"
  },
  {
    name: "Nicole B",
    rating: 5,
    comment: "My boyfriend took me here as a surprise for our 4 year anniversary, had no idea this hidden gem was here in Bellevue! We had a blast, the aesthetic is adorable and so well put together, and the owner is so incredibly sweet. The claw machines were really fun and not that hard either! The difficulty ratings were accurate and the games are so much more fun than other claw machines you'll play at a casino or bowling alley type place.",
    date: "1 week ago"
  },
  {
    name: "Cary C",
    rating: 5,
    comment: "One of the best claw machine places I've been to! Machines aren't rigged, prizes are good, workers are kind. Lots of fun! Will be back",
    date: "1 month ago"
  },
  {
    name: "Anna C",
    rating: 5,
    comment: "The attendants were very kind and helpful!! I am a claw fanatic so this spot was a gem for me. My boyfriend and I had a blast ",
    date: "2 months ago"
  },
  {
    name: "Cat C",
    rating: 5,
    comment: "This place is amazing. My 3 years old daughter is a big fun of claw machine. We spent so much on the machine which were so hard and she got really frustrated. Here she was able to get some on her own. The stuffed toys are super cute and feels good.",
    date: "3 months ago"
  }
];
